function MetaBadge({ label = "Meta Technology Partner", className = "" }) {
  return (
    <span className={`meta-badge ${className}`}>
      <span className="meta-badge__logo" aria-hidden="true">
        <i className="bi bi-meta" />
      </span>
      {label}
    </span>
  );
}

export default MetaBadge;
